// extracted by mini-css-extract-plugin
export default {"cart_badge":"cartbadge_cart_badge__3PpsT","cart_icon":"cartbadge_cart_icon__EzagF","cart_items_number":"cartbadge_cart_items_number__tvf0K"};